import { BiSave } from "react-icons/bi";
import { Button } from "@delibrandev/utils";
import { Input } from "@delibrandev/utils";
import { TextEditor } from "@delibrandev/utils";
import { GoTrash } from "react-icons/go";
import { BsArrowReturnLeft } from "react-icons/bs";

export const PolicyDetail = ({ policy, isEditing, callback }) => {
  const EditionPolicy = () => {
    return (
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <Input
            id="polityTitleInput"
            type="text"
            placeholder=""
            icon={null}
            classname=""
            iconPositionRight={true}
            label="Título"
            description=""
            defaultValue={policy.title}
          />
        </div>
        <div className="col-md-12 col-sm-12 mt-3">
          <TextEditor id="polityTextEditor" initialValue={policy.text} />
        </div>
        <div className="col-md-12 col-sm-12 mt-3 flex-end">
          <Button text={"Eliminar"} icon={<GoTrash />} customClass={"customButtonColor1"} action={() => callback("remove")} />
          <Button text={"Guardar"} icon={<BiSave />} customClass={"customButtonColor1"} action={() => callback("save")} />
          <Button text={"Cancelar"} icon={<BsArrowReturnLeft />} customClass={"customButtonColor2"} action={() => callback("cancel")} />
        </div>
      </div>
    );
  };

  const NewPolicy = () => {
    return (
      <div className="row">
        {/*<div className="col-md-12 col-sm-12">
          <Select id="polityType" values={policiesTypes} callback={() => null} label="Tipo de política" description="" classname={""} />
        </div>*/}
        <div className="col-md-12 col-sm-12 mt-2">
          <Input
            id="polityTitleInput"
            type="text"
            placeholder=""
            icon={null}
            classname=""
            iconPositionRight={true}
            label="Título"
            description=""
            defaultValue={""}
          />
        </div>
        <div className="col-md-12 col-sm-12 mt-3">
          <TextEditor id="polityTextEditor" initialValue={""} />
        </div>
        <div className="col-md-12 col-sm-12 mt-3 flex-end">
          <Button text={"Crear"} icon={<BiSave />} customClass={"customButtonColor1"} action={callback} />
          <Button text={"Cancelar"} icon={<BsArrowReturnLeft />} customClass={"customButtonColor2"} action={() => callback("cancel")} />
        </div>
      </div>
    );
  };

  return isEditing ? <EditionPolicy /> : <NewPolicy />;
};
